import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  data: null,
  error: false,
  loading: false,
  loaded: false,
  notAssignedDuration: [],
};

// Slice
const checkAssignTimeSlice = createSlice({
  name: "checkAssignTime",
  initialState,
  reducers: {
    checkStatus() {},
    setAssigned(state, action) {
      const { notAssignedDuration } = action.payload;
      return {
        ...state,
        notAssignedDuration,
      };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const { checkStatus, setAssigned, fetchDataSuccess, fetchDataFailure } =
  checkAssignTimeSlice.actions;

export default checkAssignTimeSlice.reducer;

function restructureDataByDay(data) {
  const daysOfWeek = Array.from({ length: 7 }, (_, i) => ({
    day: i,
    hours: [],
  }));

  data.forEach((item) => {
    item.days.forEach((day) => {
      daysOfWeek[day].hours.push({
        from: item.hourFrom,
        to: item.hourTo,
        message: item.message,
        serviceErrorMessage: item?.content,
      });
    });
  });

  return daysOfWeek;
}

//saga
function* fetchDataSaga(action) {
  try {
    const peerIp = yield select((state) => state.peerIp.ip);
    const { headers = {}, apiUrl, data = {} } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      },
    });
    const response = yield call(apiService.post, apiUrl, data);
    const { data: responseData } = response;

    if (response?.data?.code === "0000") {
      yield put(fetchDataSuccess(responseData.data));
      const { data } = responseData;

      const structured = restructureDataByDay(data);
      // const structured = [
      //   {
      //     day: 0,
      //     hours: [
      //       {
      //         from: 12,
      //         to: 13,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "12시부터 13시까지 점심시간으로 실시간 상담이 어려운 점 양해 부탁드립니다.\\r\\r\\r13시 이후 문의주시거나 아래를 통해 접수해 주시면 담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r식사시간: \\r\\r12:00~13:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //       {
      //         from: 9,
      //         to: 9,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "현재는 상담 가능 시간이 아닙니다.\\r\\r10시 이후에 문의하시거나 아래를 통해 접수해 주시면 \\r\\r담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r상담 센터 운영시간 : \\r\\r10:00~22:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //       {
      //         from: 22,
      //         to: 24,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "현재는 상담업무가 종료되어, 실시간 상담이 어렵습니다.\\r\\r\\r익일 10시 이후 문의주시거나 아래를 통해 접수해 주시면 담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r상담 센터 운영시간: \\r\\r10:00~22:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //     ],
      //   },
      //   {
      //     day: 1,
      //     hours: [
      //       {
      //         from: 12,
      //         to: 13,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "12시부터 13시까지 점심시간으로 실시간 상담이 어려운 점 양해 부탁드립니다.\\r\\r\\r13시 이후 문의주시거나 아래를 통해 접수해 주시면 담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r식사시간: \\r\\r12:00~13:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //       {
      //         from: 9,
      //         to: 11,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "현재는 상담 가능 시간이 아닙니다.\\r\\r10시 이후에 문의하시거나 아래를 통해 접수해 주시면 \\r\\r담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r상담 센터 운영시간 : \\r\\r10:00~22:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //       {
      //         from: 22,
      //         to: 24,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "현재는 상담업무가 종료되어, 실시간 상담이 어렵습니다.\\r\\r\\r익일 10시 이후 문의주시거나 아래를 통해 접수해 주시면 담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r상담 센터 운영시간: \\r\\r10:00~22:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //     ],
      //   },
      //   {
      //     day: 2,
      //     hours: [
      //       {
      //         from: 11,
      //         to: 19,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "12시부터 13시까지 점심시간으로 실시간 상담이 어려운 점 양해 부탁드립니다.\\r\\r\\r13시 이후 문의주시거나 아래를 통해 접수해 주시면 담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r식사시간: \\r\\r12:00~13:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //       {
      //         from: 9,
      //         to: 9,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "현재는 상담 가능 시간이 아닙니다.\\r\\r10시 이후에 문의하시거나 아래를 통해 접수해 주시면 \\r\\r담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r상담 센터 운영시간 : \\r\\r10:00~22:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //       {
      //         from: 22,
      //         to: 24,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "현재는 상담업무가 종료되어, 실시간 상담이 어렵습니다.\\r\\r\\r익일 10시 이후 문의주시거나 아래를 통해 접수해 주시면 담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r상담 센터 운영시간: \\r\\r10:00~22:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //     ],
      //   },
      //   {
      //     day: 3,
      //     hours: [
      //       {
      //         from: 12,
      //         to: 13,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "12시부터 13시까지 점심시간으로 실시간 상담이 어려운 점 양해 부탁드립니다.\\r\\r\\r13시 이후 문의주시거나 아래를 통해 접수해 주시면 담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r식사시간: \\r\\r12:00~13:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //       {
      //         from: 9,
      //         to: 9,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "현재는 상담 가능 시간이 아닙니다.\\r\\r10시 이후에 문의하시거나 아래를 통해 접수해 주시면 \\r\\r담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r상담 센터 운영시간 : \\r\\r10:00~22:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //       {
      //         from: 22,
      //         to: 24,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "현재는 상담업무가 종료되어, 실시간 상담이 어렵습니다.\\r\\r\\r익일 10시 이후 문의주시거나 아래를 통해 접수해 주시면 담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r상담 센터 운영시간: \\r\\r10:00~22:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //     ],
      //   },
      //   {
      //     day: 4,
      //     hours: [
      //       {
      //         from: 12,
      //         to: 13,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "12시부터 13시까지 점심시간으로 실시간 상담이 어려운 점 양해 부탁드립니다.\\r\\r\\r13시 이후 문의주시거나 아래를 통해 접수해 주시면 담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r식사시간: \\r\\r12:00~13:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //       {
      //         from: 9,
      //         to: 9,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "현재는 상담 가능 시간이 아닙니다.\\r\\r10시 이후에 문의하시거나 아래를 통해 접수해 주시면 \\r\\r담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r상담 센터 운영시간 : \\r\\r10:00~22:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //       {
      //         from: 22,
      //         to: 24,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "현재는 상담업무가 종료되어, 실시간 상담이 어렵습니다.\\r\\r\\r익일 10시 이후 문의주시거나 아래를 통해 접수해 주시면 담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r상담 센터 운영시간: \\r\\r10:00~22:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //     ],
      //   },
      //   {
      //     day: 5,
      //     hours: [
      //       {
      //         from: 12,
      //         to: 13,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "12시부터 13시까지 점심시간으로 실시간 상담이 어려운 점 양해 부탁드립니다.\\r\\r\\r13시 이후 문의주시거나 아래를 통해 접수해 주시면 담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r식사시간: \\r\\r12:00~13:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //       {
      //         from: 9,
      //         to: 9,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "현재는 상담 가능 시간이 아닙니다.\\r\\r10시 이후에 문의하시거나 아래를 통해 접수해 주시면 \\r\\r담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r상담 센터 운영시간 : \\r\\r10:00~22:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //       {
      //         from: 22,
      //         to: 24,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "현재는 상담업무가 종료되어, 실시간 상담이 어렵습니다.\\r\\r\\r익일 10시 이후 문의주시거나 아래를 통해 접수해 주시면 담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r상담 센터 운영시간: \\r\\r10:00~22:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //     ],
      //   },
      //   {
      //     day: 6,
      //     hours: [
      //       {
      //         from: 12,
      //         to: 13,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "12시부터 13시까지 점심시간으로 실시간 상담이 어려운 점 양해 부탁드립니다.\\r\\r\\r13시 이후 문의주시거나 아래를 통해 접수해 주시면 담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r식사시간: \\r\\r12:00~13:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //       {
      //         from: 9,
      //         to: 9,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "현재는 상담 가능 시간이 아닙니다.\\r\\r10시 이후에 문의하시거나 아래를 통해 접수해 주시면 \\r\\r담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r상담 센터 운영시간 : \\r\\r10:00~22:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //       {
      //         from: 22,
      //         to: 24,
      //         message:
      //           '{\n  "type" : "BOT",\n  "content" : [ {\n    "type" : "card",\n    "value" : [ {\n      "type" : "text",\n      "value" : "현재는 상담업무가 종료되어, 실시간 상담이 어렵습니다.\\r\\r\\r익일 10시 이후 문의주시거나 아래를 통해 접수해 주시면 담당자 확인 후 순차적으로 답변드리겠습니다.\\r\\r\\r상담 센터 운영시간: \\r\\r10:00~22:00"\n    }, {\n      "type" : "buttons",\n      "value" : [ {\n        "action" : "webLink",\n        "label" : "고객문의 접수하기",\n        "value" : "https://emartapp.emart.com/customer/customerMain.do",\n        "data" : null,\n        "sessionId" : null,\n        "badge" : null\n      } ]\n    } ]\n  } ]\n}',
      //       },
      //     ],
      //   },
      // ];
      yield put(setAssigned({ notAssignedDuration: structured }));
    } else if (response?.data?.code === "0307") {
      const { data } = responseData;
      const structured = restructureDataByDay([{ content: JSON.stringify(data), days: [ 0, 1, 2, 3, 4, 5, 6 ] }]);
      yield put(setAssigned({ notAssignedDuration: structured }));
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* checkAssignTimeSaga() {
  yield takeLatest(checkStatus.type, fetchDataSaga);
}
